import {Routes} from '@angular/router'

export const APP_ROUTES: Routes = [
  {
    path: '',
    loadChildren: () => import('./features/home/home.module').then(r => r.HomeModule),
    data: {ignoreInSitemap: true, preventIndexing: true},
  },
  {
    path: 'contact',
    loadChildren: () => import('./features/contact/contact.module').then(r => r.ContactModule),
    data: {ignoreInSitemap: true, preventIndexing: true},
  },
  {
    path: 'legal',
    loadComponent: () => import('./features/legal/legal.component').then(r => r.LegalComponent),
    data: {ignoreInSitemap: true, preventIndexing: true},
  },
  {
    path: 'legal/tos',
    loadComponent: () => import('./features/legal/tos/tos.component').then(c => c.TosComponent),
    data: {ignoreInSitemap: true, preventIndexing: true},
  },
  {
    path: 'legal/security',
    loadComponent: () => import('./features/legal/security/security.component').then(c => c.SecurityComponent),
    data: {ignoreInSitemap: true, preventIndexing: true},
  },
  {
    path: 'legal/acceptable-use',
    loadComponent: () => import('./features/legal/acceptable-use/acceptable-use.component').then(c => c.AcceptableUseComponent),
    data: {ignoreInSitemap: true, preventIndexing: true},
  },
  {
    path: 'legal/subprocessors',
    loadComponent: () => import('./features/legal/subprocessors/subprocessors.component').then(c => c.SubprocessorsComponent),
    data: {ignoreInSitemap: true, preventIndexing: true},
  },
  {
    path: 'legal/copyright-notice',
    loadComponent: () => import('./features/legal/copyright-notice/copyright-notice.component').then(c => c.CopyrightNoticeComponent),
    data: {ignoreInSitemap: true, preventIndexing: true},
  },
  {
    path: 'legal/privacy-policy',
    loadComponent: () => import('./features/legal/privacy-policy/privacy-policy.component').then(c => c.PrivacyPolicyComponent),
    data: {ignoreInSitemap: true, preventIndexing: true},
  },
  {
    path: 'legal/gdpr',
    loadComponent: () => import('./features/legal/gdpr/gdpr.component').then(c => c.GdprComponent),
    data: {ignoreInSitemap: true, preventIndexing: true},
  },
  {
    path: 'legal/dmca-policy',
    loadComponent: () => import('./features/legal/dmca-policy/dmca-policy.component').then(c => c.DmcaPolicyComponent),
    data: {ignoreInSitemap: true, preventIndexing: true},
  },
  {
    path: 'legal/paperless-policy',
    loadComponent: () => import('./features/legal/paperless-policy/paperless-policy.component').then(c => c.PaperlessPolicyComponent),
    data: {ignoreInSitemap: true, preventIndexing: true},
  },
]
